import { useEffect, useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import FormGroup from './FormGroup';

const AddressInput = ({
    name,
    label,
    value: externalValue,
    isRequired,
    placeholder,
    inlineStyle,
    showError,
    externalErrorMessage,
    requirementText = 'Address is required',
    onChange = () => {},
}) => {
    const [address, setAddress] = useState(externalValue || '');
    const [isValid, setIsValid] = useState(true);
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    useEffect(() => {
        const checkScriptLoaded = () => {
            if (window.google && window.google.maps) {
                setIsScriptLoaded(true);
            }
        };

        checkScriptLoaded();
        window.addEventListener('load', checkScriptLoaded);

        return () => {
            window.removeEventListener('load', checkScriptLoaded);
        };
    }, []);

    const handleChange = newAddress => {
        setAddress(newAddress);
        onChange({ target: { name, value: newAddress } });
    };

    const handleSelect = async selectedAddress => {
        const streetAddress = selectedAddress.split(',')[0];
        setAddress(streetAddress);
        onChange({ target: { name, value: streetAddress } });
    };

    const validateAddress = () => {
        if (isRequired && address.trim() === '') {
            setIsValid(false);
            return false;
        }
        setIsValid(true);
        return true;
    };

    useEffect(() => {
        validateAddress();
    }, [address, isRequired]);

    const errorText = showError && !isValid ? requirementText : '';
    const hasError = showError && (!isValid || externalErrorMessage);

    return (
        <>
            {isScriptLoaded ? (
                <FormGroup
                    label={label}
                    name={name}
                    externalErrorMessage={errorText}
                    showError={showError}
                    required={isRequired}
                >
                    <PlacesAutocomplete value={address} onChange={handleChange} onSelect={handleSelect}>
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                    {...getInputProps({
                                        placeholder,
                                        name,
                                        id: name,
                                        style: inlineStyle,
                                    })}
                                    className={`form-control ${hasError ? 'error' : ''}`}
                                />
                                <div className="autocomplete-dropdown-container">
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        const style = {
                                            backgroundColor: suggestion.active ? '#fafafa' : '#fffdfa',
                                            cursor: 'pointer',
                                            padding: '3px',
                                            margin: '3px',
                                        };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                                key={suggestion.placeId}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                </FormGroup>
            ) : (
                <p>Loading...</p>
            )}
        </>
    );
};

export default AddressInput;
